<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" style="position: fixed;width: 750px;" primary-title>
                    <v-flex>Support</v-flex> 
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>    
                </v-card-title>
                <v-card-text style="padding-top: 105px;">
                    <v-layout row style="border: 1px solid lightgray;margin-bottom:4px;">
                        <v-flex xs9 pa-2>
                            <span style="font-size: 15px;font-weight: bold;"> Ticket Id : </span> 
                            <span> {{ Ticket.Ticket_Id }} </span>
                        </v-flex>
                        <v-flex xs3 pa-2>
                            <span style="font-size: 15px;font-weight: bold;"> Date : </span> 
                            <span> {{ new Date(Ticket.Created_On).toLocaleDateString() }} </span>
                        </v-flex>
                    </v-layout> 
                    <v-flex pa-2 style="border: 1px solid lightgray;margin-bottom:4px;">
                           <span style="font-size: 15px;font-weight: bold;"> {{ Ticket.Course_Id ? 'Course Title' : 'Project Title :' }} </span> 
                           <span> {{ Ticket.Course_Id ? Ticket.Course_Title : Ticket.Project_Title }} </span>
                    </v-flex>
                    <v-layout row style="border: 1px solid lightgray;margin-bottom:4px;">
                        <v-flex xs4 pa-2>
                            <span style="font-size: 15px;font-weight: bold;"> Support Type : </span> 
                            <span> {{ Ticket.Support_Type }} </span>
                        </v-flex>
                        <v-flex xs4 pa-2>
                            <span style="font-size: 15px;font-weight: bold;"> Username : </span> 
                            <span> {{ Ticket.Name }} </span>
                        </v-flex>
                        <v-flex xs4 pa-2>
                            <span style="font-size: 15px;font-weight: bold;"> Email : </span> 
                            <span> {{ Ticket.Email }} </span>
                        </v-flex>
                    </v-layout> 
                    <v-flex pa-2 style="border: 1px solid lightgray;margin-bottom:4px;">
                           <span style="font-size: 15px;font-weight: bold;"> Question :</span> 
                           <span> {{ Ticket.Question }} </span>
                    </v-flex>
                    <v-flex v-if="Ticket.Description" pa-2 style="border: 1px solid lightgray;margin-bottom:4px;">
                           <span style="font-size: 15px;font-weight: bold;"> Description :</span> 
                           <span> {{ Ticket.Description }} </span>
                    </v-flex>
                    <v-layout row v-if="Ticket.Attachment && Ticket.Attachment.length > 0" pa-2 style="border: 1px solid lightgray;margin-bottom:4px;">
                           <span style="font-size: 15px;font-weight: bold;"> Attachment :</span> 
                           <span style="margin: 10px;" v-for="(image , index) in Ticket.Attachment" :key="index"> <img style="width:200px;height:200px;" :src="image"/></span>
                    </v-layout>
                   <v-flex v-if="Ticket.Conversation && Ticket.Conversation.length > 0" wrap style="height: 286px;overflow-y: auto;">
                        <div v-for="(item,index) in Ticket.Conversation" v-bind:key="index">
                        <div v-if="item.User_Type == 'Admin'" class="clsForTicketAdmin" v-html="item.Message"></div>
                        <div v-else class="clsForTicketUser" v-html="item.Message"></div>
                    </div>
                    </v-flex>
                    <v-flex style="padding-top: 15px;">
                        <v-flex style="font-weight:bold;padding-bottom: 10px;">Reply :</v-flex>
                        <v-textarea v-model="Query"></v-textarea>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-flex>
                        <section style="float:right;">
                            <v-btn color='primary' @click="SubmitAnswer">Submit Answer</v-btn>
                            <v-btn color='error' v-if="Ticket.Ticket_Status" @click="CloseTicket">Close Ticket</v-btn>
                            <v-btn color='success' v-else @click="RopenTicket">Reopen Ticket</v-btn>
                        </section>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    props: ['dialog'],
    data(){
        return {

            Ticket   : {},
            Query    : ""
        }
    },
    methods:{
        CloseDialog(){

            this.Ticket = {}
            this.Query  = ''
            this.$emit('close')
        },
        GetTicketDetails(ticket){

            this.Ticket = ticket           
        },
        SubmitAnswer(){
            
            let data = {}
            data['User_Type'] = 'Admin'
            data['Message']   = this.Query
            data['Ticket_Id'] = this.Ticket['Ticket_Id']
            this.$http.post(`${this.$store.getters.GetProductionUrl}/support/replyticket`,data)
                    .then(response =>{
                        
                        this.$emit('Update',response['data'])
                        this.CloseDialog()
                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Replied To Ticket","Color":"green","Close": false });
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
        },
        CloseTicket(){
            
            let data = {}
            data['Ticket_Id'] = this.Ticket['Ticket_Id']
            data['User_Type'] = 'Admin'
            this.$http.post(`${this.$store.getters.GetProductionUrl}/support/closeticket`,data)
                    .then(response =>{
                        
                        this.$emit('Update',response['data'])
                        this.CloseDialog();
                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Closed Ticket","Color":"green","Close": false });
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })

        },
        RopenTicket(){

             let data = {}
            data['Ticket_Id'] = this.Ticket['Ticket_Id']
            data['User_Type'] = 'Admin'     
            this.$http.post(`${this.$store.getters.GetProductionUrl}/support/reopenticket`,data)
                    .then(response =>{
                        
                        this.$emit('Update',response['data'])
                        this.CloseDialog();
                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Reopened Ticket","Color":"green","Close": false });
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })

        }
    }
}
</script>
<style scoped>
 #editor{
     height: 350px;
 }
  .clsForTicketAdmin{
    margin: 10px 8px;
    padding: 18px 12px;
    text-align: right;
    background: #31356c;
    color: white;
    word-wrap: break-word;
 }
  .clsForTicketUser{
    margin: 10px 8px;
    padding: 18px 12px;
    text-align: left;
    color: black;
    word-wrap: break-word;
    border: 1px solid lightgray;
 }
</style>